"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionChannel = void 0;
const topic_1 = require("../../topic");
const SESSION_CHANNEL = 'session';
class SessionChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = SESSION_CHANNEL;
        this.topics = {
            appInitSucceeded: new topic_1.Topic('appInitSucceeded', SESSION_CHANNEL, this._logger),
            appInitFailed: new topic_1.Topic('appInitFailed', SESSION_CHANNEL, this._logger),
            appClosed: new topic_1.Topic('appClosed', SESSION_CHANNEL, this._logger),
            appError: new topic_1.Topic('appError', SESSION_CHANNEL, this._logger),
            minimizeApp: new topic_1.Topic('minimizeApp', SESSION_CHANNEL, this._logger),
            appMinimized: new topic_1.Topic('appMinimized', SESSION_CHANNEL, this._logger),
            appMaximized: new topic_1.Topic('appMaximized', SESSION_CHANNEL, this._logger),
            clientInit: new topic_1.Topic('clientInit', SESSION_CHANNEL, this._logger),
            clientInitSucceeded: new topic_1.Topic('clientInitSucceeded', SESSION_CHANNEL, this._logger),
            heartBeat: new topic_1.Topic('heartBeat', SESSION_CHANNEL, this._logger),
            inactivityTimeout: new topic_1.Topic('inactivityTimeout', SESSION_CHANNEL, this._logger),
            sportWrapperInit: new topic_1.Topic('sportWrapperInit', SESSION_CHANNEL, this._logger),
            subscribedToMessageBroker: new topic_1.Topic('subscribedToMessageBroker', SESSION_CHANNEL, this._logger),
            appClosedSuccess: new topic_1.Topic('appClosedSuccess', SESSION_CHANNEL, this._logger),
            postLoginActionsFinished: new topic_1.Topic('postLoginActionsFinished', SESSION_CHANNEL, this._logger),
            webLoginClosed: new topic_1.Topic('webLoginClosed', SESSION_CHANNEL, this._logger),
            pendingActionClosed: new topic_1.Topic('pendingActionClosed', SESSION_CHANNEL, this._logger),
            PendingActionFinished: new topic_1.Topic('PendingActionFinished', SESSION_CHANNEL, this._logger),
            closeIntent: new topic_1.Topic('closeIntent', SESSION_CHANNEL, this._logger),
            closeIntentResult: new topic_1.Topic('closeIntentResult', SESSION_CHANNEL, this._logger),
            clientInitFailed: new topic_1.Topic('clientInitFailed', SESSION_CHANNEL, this._logger),
            appClosing: new topic_1.Topic('appClosing', SESSION_CHANNEL, this._logger),
            actionStarted: new topic_1.Topic('actionStarted', SESSION_CHANNEL, this._logger),
            actionCompleted: new topic_1.Topic('actionCompleted', SESSION_CHANNEL, this._logger),
            actionCancelled: new topic_1.Topic('actionCancelled', SESSION_CHANNEL, this._logger),
            loginAborted: new topic_1.Topic('loginAborted', SESSION_CHANNEL, this._logger),
            sportSessionDetails: new topic_1.Topic('sportSessionDetails', SESSION_CHANNEL, this._logger),
        };
    }
}
exports.SessionChannel = SessionChannel;
//# sourceMappingURL=session.channel.js.map